module.exports = __webpack_public_path__ + "img/by_request_only_icon.334ac9cb.svg";